export default {
    "dashboard.nav.dashboard": "Tableau de bord",
    "dashboard.nav.flashcards": "Flashcards",
    "dashboard.nav.quiz": "Quiz",
    "dashboard.nav.audio": "Résumés Audio",
    "dashboard.nav.study_guide": "Guide d'étude",
    "dashboard.nav.exam": "Examen Blanc",
    "dashboard.nav.stats": "Statistiques",
    "dashboard.nav.settings": "Paramètres",
    "dashboard.nav.subscription": "Abonnement",
    "dashboard.nav.logout": "Déconnexion",
    "dashboard.nav.new_quiz": "Nouveau Quiz",
    "dashboard.nav.epub": "Livre (EPUB)",
    "dashboard.epub.subtitle": "Lisez confortablement le guide officiel au format EPUB.",

    "dashboard.welcome.title": "Bonjour, {{name}} !",
    "dashboard.welcome.description": "Continuez là où vous vous êtes arrêté. Votre prochaine session vous attend.",
    "dashboard.welcome.last_activity": "Dernière activité : {{time}}",
    "dashboard.welcome.never": "Jamais",

    "dashboard.stats.completed_quiz": "Quiz Complétés",
    "dashboard.stats.progression": "Progression",
    "dashboard.stats.accuracy": "Précision",
    "dashboard.stats.to_review": "À revoir",

    "dashboard.main.progression": "Progression Globale",
    "dashboard.main.details": "Voir les détails",
    "dashboard.main.mastery": "Maîtrise",
    "dashboard.main.level": "Votre niveau",
    "dashboard.main.level_beginner": "Débutant",
    "dashboard.main.level_intermediate": "Intermédiaire",
    "dashboard.main.level_advanced": "Avancé",
    "dashboard.main.cta_continue": "Continuez à étudier régulièrement pour améliorer votre mémorisation.",
    "dashboard.main.total_answers": "Réponses totales",
    "dashboard.main.correct_answers": "Réponses correctes",
    "dashboard.main.current_streak": "Série actuelle",

    "dashboard.badges.title": "Mes Badges",
    "dashboard.badges.count": "{{count}} badge",
    "dashboard.badges.count_plural": "badges débloqués",
    "dashboard.badges.empty": "Complétez des quiz pour débloquer vos premiers badges !",

    "dashboard.premium.title": "Passez au Premium !",
    "dashboard.premium.description": "Accédez à tous les outils et contenus exclusifs pour maximiser vos chances de réussir l'examen.",
    "dashboard.premium.cta": "Voir les offres",

    "dashboard.exam.title": "Examen Blanc",
    "dashboard.exam.subtitle": "20 questions / 45 minutes",
    "dashboard.exam.description": "Simulez les conditions réelles avec un examen chronométré.",
    "dashboard.exam.cta": "Lancer un examen",

    "dashboard.activity.title": "Activité Récente",
    "dashboard.activity.empty": "Aucune activité récente. Commencez un quiz !",
    "dashboard.activity.view_all": "Voir tout l'historique",
    "dashboard.activity.time_just_now": "À l'instant",
    "dashboard.activity.time_min": "Il y a {{count}} min",
    "dashboard.activity.time_hours": "Il y a {{count}} h",
    "dashboard.activity.time_yesterday": "Hier",
    "dashboard.activity.time_days": "Il y a {{count}} jours",

    "dashboard.learning.title": "Catégories d'apprentissage",
    "dashboard.learning.progression": "Progression",
    "dashboard.learning.flashcards": "Flashcards",
    "dashboard.learning.quiz": "Quiz",
    "dashboard.learning.unlock": "Débloquer",
    "dashboard.learning.finished": "Terminé",
    "dashboard.learning.pro": "PRO",

    "dashboard.payment.processing": "Activation de votre abonnement...",
    "dashboard.payment.success_title": "Paiement réussi !",
    "dashboard.payment.success_message": "Votre abonnement est maintenant actif. Profitez de toutes les fonctionnalités !"
};
